import {useRef} from "preact/compat";

export const useRemoveModal = props => {
    // Destructured props
    const {
        setOpen,
        handleProductDelete,
        source
    } = props;

    // Ref for the cancel button
    const cancelButtonRef = useRef(null);

    // Handles the confirmation action
    const handleClick = stockItem => {
        // Closes the modal
        setOpen(false);

        // Performs the delete action
        handleProductDelete({
            ...(source === "default" ? {stockItem} : {itemId: stockItem})
        })
    }

    return {
        cancelButtonRef,
        handleClick
    }
}
